// frontend/src/core/services/checklistService.ts
import { apiClient } from './apiClient';
import { Checklist, CreateChecklistPayload, UpdateChecklistPayload } from '../types';

export const checklistService = {
  async getAll(): Promise<Checklist[]> {
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.get<Checklist[]>('/checklists');
  },

  async getById(id: string): Promise<Checklist> {
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.get<Checklist>(`/checklists/${id}`);
  },

  async getByQR(qrCode: string): Promise<{ checklist: Checklist }> {
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.get<{ checklist: Checklist }>(`/checklists/qr/${qrCode}`);
  },

  async create(payload: CreateChecklistPayload): Promise<Checklist> {
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.post<Checklist>('/checklists', payload);
  },

  async update(payload: UpdateChecklistPayload): Promise<Checklist> {
    const { id, ...data } = payload;
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.put<Checklist>(`/checklists/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    // 🔥 CAMBIO: eliminar '/api' inicial
    return apiClient.delete(`/checklists/${id}`);
  },
};